/**
 * Created by karora on 14/03/17.
 */
import { Pipe, PipeTransform } from '@angular/core';
/*
 * Format a version [ww[xx]]yyzz into w.x.y.z or x.y.z or 0.y.z
 */
@Pipe({name: 'version'})
export class VersionPipe implements PipeTransform {
  transform(v: number | string): string {
    let value = v as number;
    if (isNaN(value)) {
      return v as string;
    }
    try {
      let z = value % 100;
      value = (value - z) / 100;
      let y = value % 100;
      value = (value - y) / 100;
      let x = value % 100;
      if (value <= x) {
        return '' + x + '.' + y + '.' + z;
      }
      value = (value - x) / 100;
      return '' + value + '.' + x + '.' + y + '.' + z;
    } catch (err) {
      console.log(err);
      return v.toLocaleString();
    }
  }
}
